import { forwardRef } from "react";
import type { ChatTask } from "@/sdk/agent/chat";

import { ListItemSeparator } from "./ListItemSeparator";

// Separator for when the expert/agent joined the chat
export const AgentJoinedSeparator = forwardRef<HTMLDivElement, { chatTask: ChatTask }>(function AgentJoinedSeparator(
    { chatTask },
    ref,
) {
    const joinedAt = chatTask.assignedAt;
    if (!joinedAt) return null;
    const joinedTime = joinedAt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    const copy = chatTask.wasTaskNeglected
        ? `Neglected chat transferred to you at ${joinedTime}`
        : `You joined the chat at ${joinedTime}`;

    return <ListItemSeparator label={copy} ref={ref} />;
});
